export default function checkIsProcessingView(viewsInProcess: string[]) {
  return (view) => viewsInProcess.some(viewName => viewName === view.groupname);
}
